import React from 'react';

/**
 * Indicador de OS nova sem dono (disputa) + ação Assumir atendimento.
 */
export function BoardChatUnclaimedOsHint({ count = 0, busy = false, onClaim }) {
  const n = Number(count) || 0;
  if (n < 1) return null;
  const label =
    n === 1 ? '1 nova OS sem atendente' : `${n} novas OS sem atendente`;
  return (
    <span className="bch-session-unclaimed" role="status">
      <span className="bch-session-unclaimed-dot" aria-hidden="true" />
      <span className="bch-session-unclaimed-text">{label}</span>
      <button
        type="button"
        className="bch-session-unclaimed-claim"
        disabled={busy}
        onClick={(e) => {
          e.stopPropagation();
          onClaim?.();
        }}
      >
        {busy ? 'Assumindo…' : 'Assumir atendimento'}
      </button>
    </span>
  );
}
